import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMenu, FiBell, FiSearch, FiSettings, FiUser } = FiIcons;

const Header = ({ setSidebarOpen }) => {
  return (
    <header className="bg-white shadow-sm border-b border-secondary-200">
      <div className="flex items-center justify-between px-6 py-4">
        <div className="flex items-center space-x-4">
          <button 
            onClick={() => setSidebarOpen(true)}
            className="lg:hidden p-2 rounded-lg hover:bg-secondary-100 transition-colors"
          >
            <SafeIcon icon={FiMenu} className="w-5 h-5 text-secondary-600" />
          </button>
          
          <div className="relative">
            <SafeIcon icon={FiSearch} className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-secondary-400" />
            <input
              type="text"
              placeholder="Search feedback, customers, or insights..."
              className="pl-10 pr-4 py-2 w-80 bg-secondary-50 border border-secondary-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent"
            />
          </div>
        </div>

        <div className="flex items-center space-x-4">
          <motion.div 
            whileHover={{ scale: 1.05 }}
            className="relative"
          >
            <button className="p-2 rounded-lg hover:bg-secondary-100 transition-colors relative">
              <SafeIcon icon={FiBell} className="w-5 h-5 text-secondary-600" />
              <span className="absolute -top-1 -right-1 w-3 h-3 bg-danger-500 rounded-full"></span>
            </button>
          </motion.div>
          
          <button className="p-2 rounded-lg hover:bg-secondary-100 transition-colors">
            <SafeIcon icon={FiSettings} className="w-5 h-5 text-secondary-600" />
          </button>
          
          <div className="flex items-center space-x-3 pl-4 border-l border-secondary-200">
            <div className="w-8 h-8 bg-gradient-to-br from-primary-500 to-primary-600 rounded-full flex items-center justify-center">
              <SafeIcon icon={FiUser} className="w-4 h-4 text-white" />
            </div>
            <div className="hidden md:block">
              <p className="text-sm font-medium text-secondary-900">Sarah Johnson</p>
              <p className="text-xs text-secondary-500">Admin</p>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;